














































































































































































































































































































































import { Component, mixins } from 'nuxt-property-decorator'
import { declension } from '~/assets/functions/declension'
import MixinCart from '~/assets/mixins/cart'

@Component({
  filters: {
    filterQuantity(num: number) {
      return (
        num.toString() + ' ' + declension(num, ['товар', 'товара', 'товаров'])
      )
    },
  },
})
export default class ComponentMobileOrderCart extends mixins(MixinCart) {}
